import theme from "@styles/theme";

/**
 * 알파값이 있는 색상을 배경색과 블렌딩하여 동일한 시각 효과의 불투명 색상으로 변환
 * @param {string} foregroundColor - 전경색 (rgb 또는 hex 형식)
 * @param {number} alpha - 알파값 (0~1 사이)
 * @param {string} backgroundColor - 배경색 (rgb 또는 hex 형식)
 * @returns {string} - 불투명한 rgb 색상 문자열
 */
const calculateOpaqueColor = (foregroundColor, alpha, backgroundColor = theme.palette.background.default) => {
    // hex를 rgb 배열로 변환하는 헬퍼 함수
    const hexToRgb = (hex) => {
        // #으로 시작하면 제거
        hex = hex.replace(/^#/, "");

        // 3자리 hex를 6자리로 확장 (#RGB -> #RRGGBB)
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        // hex를 rgb 배열로 변환
        return [
            parseInt(hex.substring(0, 2), 16),
            parseInt(hex.substring(2, 4), 16),
            parseInt(hex.substring(4, 6), 16),
        ];
    };

    // rgb 문자열을 배열로 변환하는 헬퍼 함수
    const rgbStringToArray = (rgb) => {
        const matches = rgb.match(/\d+/g);
        if (matches && matches.length >= 3) {
            return matches.slice(0, 3).map(Number);
        }
        return [0, 0, 0];
    };

    // 입력 색상을 rgb 배열로 변환
    let fgRgb = foregroundColor.startsWith("#") ? hexToRgb(foregroundColor) : rgbStringToArray(foregroundColor);

    let bgRgb = backgroundColor.startsWith("#") ? hexToRgb(backgroundColor) : rgbStringToArray(backgroundColor);

    // 알파 블렌딩 계산
    const blended = fgRgb.map((channel, i) => {
        return Math.round(channel * alpha + bgRgb[i] * (1 - alpha));
    });

    // rgb 문자열로 반환
    return `rgb(${blended[0]}, ${blended[1]}, ${blended[2]})`;
};

export default calculateOpaqueColor;
